module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.userFormData.user_id) ? _c('van-cell', {
    attrs: {
      "title": "用户选择",
      "is-link": "",
      "value": "请选择用户"
    },
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }) : _c('van-cell', {
    attrs: {
      "title": "用户选择",
      "is-link": "",
      "value": "请选择用户"
    },
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_c('template', {
    slot: "default"
  }, [_c('span', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.userInfo.name) + " " + _vm._s(_vm.userInfo.phone))])])], 2), _vm._v(" "), (!_vm.userFormData.type) ? _c('van-cell', {
    attrs: {
      "title": "角色类型",
      "is-link": "",
      "value": "请选择角色类型"
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }) : _c('van-cell', {
    attrs: {
      "title": "角色类型",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }, [_c('template', {
    slot: "default"
  }, [_c('span', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.userFormData.type))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [(!_vm.saveLoading) ? _c('van-button', {
    attrs: {
      "type": "danger",
      "size": "large"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")]) : _c('van-button', {
    attrs: {
      "type": "danger",
      "size": "large"
    }
  }, [_vm._v("保存中...")])], 1), _vm._v(" "), _c('UserPicker', {
    attrs: {
      "show": _vm.show,
      "limit": 5
    },
    on: {
      "onClonse": _vm.onClonse,
      "onUserAdd": _vm.onUserAdd
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.roleType
    },
    on: {
      "cancel": function($event) {
        _vm.showPicker = false
      },
      "confirm": _vm.onConfirm
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60ee3562","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/site/SiteSettingUserCreate.vue
// module id = 2433
// module chunks = 0